<template>
  <div>
    <el-select class="select-report" popper-class="report-popper"  v-model="activeIndex" style="margin-bottom: 10px;" placeholder="请选择报表" @change="handleSubmit">
      <el-option
        v-for="(item, index) in items"
        :key="index"
        :label="item.link"
        :value="index">
      </el-option>
  </el-select>
    <!-- <el-button type="primary" @click="showDialog" class="btn-select">{{
      currentItem
    }}</el-button> -->
    <el-dialog
      class="dialog-wrapper"
      title="报告选择"
      width="25%"
      :visible.sync="dialogVisible"
      @close="handleCancel"
    >
      <div class="dialog-content">
        <div
          :class="{ active: activeIndex === index, item: true }"
          @click="clickItem(item.link, index)"
          v-for="(item, index) in items"
          :key="index"
        >
          {{ item.link }}
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel()">取 消</el-button>
        <el-button type="primary" @click="handleSubmit()">确 定</el-button>
      </div>
    </el-dialog>
    <el-tabs v-model="activeName" type="card" class="_tabs">
      <!-- <el-tab-pane :label="currentItem" name="first"> -->
      <el-row :gutter="0">
        <el-col :span="24">
          <div class="searchBox">
            <el-col :span="24">
              <el-form
                :inline="true"
                :model="form"
                label-position="left"
                label-width="100px"
                align="left"
              >
                <el-form-item
                  :label="item['columnNameFilter']"
                  style="margin-right: 10px"
                  v-show="item.isShow == '1'"
                  v-for="(item, index) in formItems"
                  :key="index+'form1'"
                >
                  <el-select
                    v-model="form[item['columnName']]"
                    remote
                    size="small"
                    collapse-tags
                    placeholder="Select"
                    filterable
                    v-loadmore="(e) => handleLoadmore(e, item)"
                    :remote-method="(e) => remoteMethod(e, item)"
                    @focus="handleFoucus($event, item)"
                    :multiple="item['filterType']=='M'"
                    v-if="!item[item['columnName'] + 'Multiple']"
                  >
                    <el-option
                      v-for="itemOp in item[item['columnName'] + 'Options']"
                      :key="itemOp.rowValue"
                      :label="itemOp.rowValue"
                      :value="itemOp.rowValue"
                    ></el-option>
                  </el-select>

                  <el-select
                    v-model="form[item['columnName']]"
                    remote
                    size="small"
                    collapse-tags
                    placeholder="Select"
                    @change="
                      changeSelect(
                        item['columnName'] + 'Checked',
                        item[item['columnName'] + 'Options'],
                        item['columnName']
                      )
                    "
                    filterable
                    v-loadmore="(e) => handleLoadmore(e, item)"
                    :remote-method="(e) => remoteMethod(e, item)"
                    reserve-keyword
                    @focus="handleFoucus($event, item)"
                    :multiple="item['filterType']=='M'"
                    v-if="item[item['columnName'] + 'Multiple']"
                  >
                    <el-checkbox
                      v-model="formData[item['columnName'] + 'Checked']"
                      @change="
                        handleCheckAll(
                          item['columnName'] + 'Checked',
                          item[item['columnName'] + 'Options'],
                          item['columnName']
                        )
                      "
                      v-show="item['filterType']=='M'"
                      >全选</el-checkbox
                    >
                    <el-option
                      v-for="itemOp in item[item['columnName'] + 'Options']"
                      :key="itemOp.rowValue"
                      :label="itemOp.rowValue"
                      :value="itemOp.rowValue"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  :label="item['columnNameFilter']"
                  style="margin-right: 10px"
                  v-show="item.isShow == '0' && isShowAllFormItems"
                  v-for="(item, index) in formItems"
                  :key="index+'form2'"
                >
                  <!-- 为0显示 -->
                  <el-select
                    v-model="form[item['columnName']]"
                    remote
                    size="small"
                    collapse-tags
                    placeholder="Select"
                    filterable
                    v-loadmore="(e) => handleLoadmore(e, item)"
                    :remote-method="(e) => remoteMethod(e, item)"
                    @focus="handleFoucus($event, item)"
                    :multiple="item['filterType']=='M'"
                    v-if="!item[item['columnName'] + 'Multiple']"
                  >
                    <el-option
                      v-for="itemOp in item[item['columnName'] + 'Options']"
                      :key="itemOp.rowValue"
                      :label="itemOp.rowValue"
                      :value="itemOp.rowValue"
                    ></el-option>
                  </el-select>

                  <el-select
                    v-model="form[item['columnName']]"
                    remote
                    size="small"
                    collapse-tags
                    placeholder="Select"
                    @change="
                      changeSelect(
                        item['columnName'] + 'Checked',
                        item[item['columnName'] + 'Options'],
                        item['columnName']
                      )
                    "
                    filterable
                    v-loadmore="(e) => handleLoadmore(e, item)"
                    :remote-method="(e) => remoteMethod(e, item)"
                    reserve-keyword
                    @focus="handleFoucus($event, item)"
                    :multiple="item['filterType']=='M'"
                    v-if="item[item['columnName'] + 'Multiple']"
                  >
                    <el-checkbox
                      v-model="formData[item['columnName'] + 'Checked']"
                      @change="
                        handleCheckAll(
                          item['columnName'] + 'Checked',
                          item[item['columnName'] + 'Options'],
                          item['columnName']
                        )
                      "
                      v-show="item['filterType']=='M'"
                    >全选</el-checkbox
                    >
                    <el-option
                      v-for="itemOp in item[item['columnName'] + 'Options']"
                      :key="itemOp.rowValue"
                      :label="itemOp.rowValue"
                      :value="itemOp.rowValue"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  v-if="formData['tbl'] === 'portal_target_download'"
                >
                  <el-radio-group v-model="formData['flex']">
                    <el-radio :label="1" @change="reFlex">竖版</el-radio>
                    <el-radio :label="2" @change="reFlex">横版</el-radio>
                  </el-radio-group>
                </el-form-item>
                <!-- <el-form-item>
                <el-button
                  type="primary"
                  v-show="!isShowAllFormItems"
                  v-on:click="() => (isShowAllFormItems = !isShowAllFormItems)"
                  >展开 <i class="el-icon-arrow-down el-icon--right"></i
                ></el-button>
                <el-button
                  type="primary"
                  v-show="isShowAllFormItems"
                  v-on:click="() => (isShowAllFormItems = !isShowAllFormItems)"
                  >收起 <i class="el-icon-arrow-up el-icon--right"></i
                ></el-button>
              </el-form-item> -->
                <div
                  class="open"
                  v-if="!isShowAllFormItems"
                  @click="() => (isShowAllFormItems = !isShowAllFormItems)"
                >
                  <div>展开更多</div>
                  <img src="../../assets/icon_down.png" alt="" />
                </div>
                <div
                  class="open"
                  v-if="isShowAllFormItems"
                  @click="() => (isShowAllFormItems = !isShowAllFormItems)"
                >
                  <div>收起更多</div>
                  <img src="../../assets/icon_up.png" alt="" />
                </div>
              </el-form>

              <div class="line"></div>
            </el-col>
            <el-col>
              <el-button type="primary" style="margin-right: 20px;" class="btn" v-on:click="reGetList"
                >查询</el-button
              >
              <el-button type="primary" class="btn" v-on:click="toData2"
                >下载</el-button
              >
            </el-col>
          </div>
        </el-col>
        <el-col :span="24" style="margin-top: 8px;">
          <el-table
            :data="formData['tableData']"
            tooltip-effect="dark"
            style="width: 100%; border-radius: 20px 20px 0 0; overflow: hidden"
            :header-cell-style="headerStyle"
            :cell-style="cellStyle"
          >
            <el-table-column
              v-for="(header, index) in formData['tableHeaders']"
              :key="index"
              :label="header"
              align="center"
              width="160px"
            >
              <template slot-scope="scope">
                {{ scope.row[header] }}
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="24">
          <div style="float: right; margin-top: 20px">
            <el-pagination
              @current-change="handleCurrentChange"
              background
              layout="prev, pager, next"
              :total="total"
            ></el-pagination>
          </div>
        </el-col>
      </el-row>
      <!-- </el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import {
  getUserInfoList,
  updateUserInfo,
  addUserInfo,
  getDynamicSQL,
  getFormItemsList,
  getOptionByPermission2,
  addDownloadExport,
  getReport, getReportColumns,
} from "../../api/api";
import da from "element-ui/src/locale/lang/da";
import debounce from "./debounce";
export default {
  directives: {
    // select 组件出发下拉加载更多
    loadmore: {
      inserted(el, binding) {
        const dom = el.querySelector(
          ".el-select-dropdown .el-select-dropdown__wrap"
        ); // 获取下拉框元素
        dom.addEventListener("scroll", function () {
          // 监听元素触底
          const condition =
            this.scrollHeight.toFixed(0) - this.scrollTop.toFixed(0) <=
            this.clientHeight;
          // console.log(this.scrollHeight.toFixed(0) - this.scrollTop.toFixed(0));
          // console.log(this.scrollHeight.toFixed(0), this.scrollTop.toFixed(0));
          // console.log(this.clientHeight);
          if (condition) {
            binding.value();
          }
        });
      },
    },
  },
  data() {
    return {
      loading: false,
      addUserFlag: false,
      formData: {
        flag: false,
        tableHeaders: [],
        tableData: [],
        sSelectFieldName: ""
      },
      formItems: [],
      items: [],
      headerStyle: {
        height: "50px",
        backgroundColor: "#000",
        color: "#fff",
        padding: "0px",
      },
      cellStyle: {
        height: "55px",
      },
      isShowAllFormItems: false, // 是否展示全部的筛选项
      defItems: [
        {
          link: "OP指标报告",
          db: "",
          tbl: "portal_target_download",
        },
        {
          link: "销售水单",
          db: "销售水单",
          tbl: "Portal_Fact_SalesDetail_download",
        },
      ],
      currentItem: "选择报表",
      activeIndex: "",
      dialogVisible: false,
      activeName: "first",
      sSchemaName: "business_data.dbo",
      form: {},

      options: [
        {
          id: 1,
          name: "竖版",
        },
        {
          id: 2,
          name: "横版",
        },
      ],
      filters: {
        pageSize: 10,
        currentPage: 1,
      },
      total: 0,
      tableData3: [],
      tableDataVertical: [],
      tableDataCross: []
    };
  },
  computed: {
    // watchedFormValue() {
    //   return this.form[this.formData.permissionColumn];
    // },
  },
  watch: {
    currentItem() {
      delete this.formData.flex;
      this.formItems = [];
      this.form = {};
      this.getFormItems();
      // this.getList();
    },
    watchedFormValue(newVal, oldVal) {
    },
  },
  mounted() {
    
    let today = new Date();
    let currentMonth = today.getMonth() + 1;
    getReport({}).then((res1) => {
      var data1 = res1.data;
      if (data1.length == 0) {
        return;
      }

      for (let i = 0; i < data1.length; i++) {
        this.items.push({
          link: data1[i]["report_name"],
          db: data1[i]["report_name"],
          tbl: data1[i]["tbl_name"],
        });
      }
      // 初始化
      if (this.items.length > 0) {
        const reportID = this.$route.query.id;
        console.log(reportID, 'reportID');
        if (reportID) {
          if (reportID === 'DM_DE_DS_BMM') {
            this.clickItem(this.items[6].link, 6);
            this.handleSubmit();
          } else if (reportID === 'RM_CM_T1_Sellout') {
            this.clickItem(this.items[8].link, 8);
            this.handleSubmit();
          } else if (reportID === 'DM_DE_DS_BRM') {
            this.clickItem(this.items[7].link, 7);
            this.handleSubmit();
          } else if (reportID === 'DE_DS_KPI') {
            this.clickItem(this.items[4].link, 4);
            this.handleSubmit();
          } else if (reportID === 'DM_BMM_UL_KPI') {
            this.clickItem(this.items[5].link, 5);
            this.handleSubmit();
          } else if (reportID === 'Endcon_KPI') {
            this.clickItem(this.items[3].link, 3);
            this.handleSubmit();
          } else if (reportID === 'RM_T1_T2_KPI') {
            this.clickItem(this.items[9].link, 9);
            this.handleSubmit();
          } else if (reportID === 'BRM_KPI') {
            this.clickItem(this.items[0].link, 0);
            this.handleSubmit();
          } else {
            this.clickItem(this.items[0].link, 0);
            this.handleSubmit();
          }
        } else {
          this.clickItem(this.items[0].link, 0);
          this.handleSubmit();
        }
      }
    });
  },
  methods: {
    changeSelect: function (check, options, form) {
      if (this.form[form].length === options.length) {
        this.formData[check] = true;
      } else {
        this.formData[check] = false;
      }
    },
    clickItem(link, index) {
      console.log(index, 'activeIndex');
      this.activeIndex = index;
      // this.currentItem = link
    },
    fillOptionPermission(
      data,
      name,
      options,
      filterName = "row_name",
      fieldName,
      fieldValue
    ) {
      var filters = data.filter(function (item) {
        return (
          item[filterName] === name &&
          item["field_name"] == fieldName &&
          item["field_value"] == fieldValue
        );
      });
      if (filters.length == 0) {
        return;
      }
      options.length = 0;
      filters.forEach((each) => {
        var filter = options.filter((item) => item.id === each["row_value"]);
        if (filter.length === 0) {
          options.push({
            id: each["row_value"],
            name: each["row_value"],
          });
        }
      });
    },
    getFormItems() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var _this = this;
      var formItems = {};
      delete _this.formData.flex;
      getFormItemsList({
        reportName: this.items[this.activeIndex].link,
        tblName: this.items[this.activeIndex].tbl,
      }).then((res) => {
        var data = res.data.map((item) => ({
          ...item,
          currentPage: 1,
          loading: false,
        }));
        // console.log(data, "formItems");
        data.sort((obj1, obj2) => {
          return obj1.sort - obj2.sort;
        });
        for (const item of data) {
          var formItem = formItems[item["tbl_name"] + item["columnName"]];
          if (formItem) {
            continue;
          } else {
            formItem = {};
            formItem["columnNameFilter"] = item["columnNameFilter"];
            formItem["columnName"] = item["columnName"];
            formItem["isShow"] = item["isShow"];
            formItem["filterType"] = item["filterType"];
            formItem[formItem["columnName"] + "Multiple"] = true;
            // formItem[formItem['columnName']+'Checked']=false;
            _this[formItem["columnName"] + "Checked"] = false;
            formItem[formItem["columnName"] + "Options"] = [];
            // _this.fillOption(data, formItem['columnName'], formItem[formItem['columnName']+'Options']);
            formItems[item["tbl_name"] + item["columnName"]] = formItem;
          }
        }
        this.formData["flag"] = true;
        _this.$set(_this, "formItems", formItems);
        this.total = 0;
        this.formData['tableData'].Length = 0;
        this.formData['tableHeaders'].length = 0;
        loading.close();
        if (_this.formData["tbl"] === "portal_target_download") {
          // _this.formData.flex=1;
          _this.$set(_this.formData, "flex", 1);
        }
      });
    },
    getFormItemsOptionsList(item, keywords = "") {
      const params = {
        reportName: this.items[this.activeIndex].link,
        tblName: this.items[this.activeIndex].tbl,
        columnName: item.columnName,
        keywords,
        currentPage: item.currentPage,
        pageSize: 20,
      };
      this.loading = true;
      getOptionByPermission2(params)
        .then((res) => {
          // console.log(res.data, 1111);
          this.loading = false;
          let records = [];
          if (params.currentPage == 1) {
            records = res.data;
          } else {
            records = item[item["columnName"] + "Options"].concat(res.data);
          }
          item[item["columnName"] + "Options"] = records;
          this.changeSelect(
            item["columnName"] + "Checked",
            item[item["columnName"] + "Options"],
            item["columnName"]
          );
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getList: function () {
      var table = this.formData["tbl"];
      if (this.formData["tbl"] === "portal_target_download") {
        table = "portal_target_cross_download";
        if (this.formData["flex"]) {
          if (this.formData.flex === 1) {
            table = "portal_target_cross_download";
          } else {
            table = "portal_target_vertical_download";
          }
        } else {
          // this.formData.flex = 1 ;
          // this.$set(this.formData, 'flex',1);
        }
      }
      var arr = [];
      for (let formKey in this.form) {
        if (this.form[formKey] instanceof Array) {
          if (this.form[formKey].length > 0) {
            arr = arr.concat(
              formKey +
                "  in  (" +
                this.form[formKey].map((item) => "N'" + item + "'").join(",") +
                ")"
            );
          }
        } else {
          if (this.form[formKey] !== "") {
            arr = arr.concat(formKey + "  in  (N'" + this.form[formKey] + "')");
          }
        }
      }
      // console.log(this.form, 213123123);
      var param = Object.assign(
        {
          sSelectName: table,
          sSelectFieldName: "*",
          reportName: this.items[this.activeIndex].link,
          extBody: 1,
          sSelectFilter: arr.join(" and "),
          sSchemaName: this.sSchemaName,
        },
        this.form,
        this.filters
      );

      var  reportColumnsName = [];
      getReportColumns({
        reportName: this.items[this.activeIndex].link,
        tblName: table,
      }).then((res1) => {

        if(res1.data.length>0) {
          res1.data.forEach((item1) => {
            reportColumnsName.push(item1.columnName + " as '" + item1.columnShowName+"' ");
          });
          param.sSelectFieldName = reportColumnsName.join(",");
        }

        this.formData['sSelectFieldName']=param.sSelectFieldName;

        getDynamicSQL(param).then((res) => {
          // this.$set(this, 'total', res.page.totalCount * 1);
          this.total = res.page.totalCount * 1;
          // this.formData['total'] = this.total;

          this.$set(this.formData, "tableData", res.data);
          var headers = Object.keys(res.data[0]).filter(
              (key) => key !== "__row_number__"
          );
          this.formData["tableHeaders"] = headers;
        });
      });


    },
    handleCancel() {
      this.dialogVisible = false;
    },
    handleCheckAll: function (check, options, form) {
      if (this.formData[check]) {
        this.form[form] = options.map((item) => item.rowValue);
      } else {
        this.form[form] = [];
      }

      // console.log(form, 1213);
      // console.log(this.form, "hahahah");
    },
    handleCurrentChange(page) {
      this.filters.currentPage = page;
      this.getList();
    },
    handleFoucus(e, item) {
      //初始化第一次加载的时候触发
      // console.log(item[item["columnName"] + "Options"].length);
      // console.log(item[item["columnName"] + "Options"]);
      if (
        !item[item["columnName"] + "Options"] ||
        !item[item["columnName"] + "Options"].length
      ) {
        // console.log(item);
        item.currentPage = 1;
        this.getFormItemsOptionsList(item);
      }
    },
    handleLoadmore(e, item) {
      // console.log(item, 1111);
      // console.log("SELECT LOADMORE");
      item.currentPage++;
      this.getFormItemsOptionsList(item);
    },
    // fillOption(data, name, options,filterName='columnName') {
    //   var filters = data.filter(function (item) {
    //     return (item[filterName] === name)
    //   })
    //   if (filters.length == 0) {
    //     return;
    //   }
    //   options.length = 0;
    //   filters.forEach(each => {
    //     var filter = options.filter(item => item.id === each.value);
    //     if (filter.length === 0) {
    //       options.push({
    //         id: each.value,
    //         name: each.value,
    //         sort: each.sort
    //       })
    //     }
    //   });

    // },

    handleSubmit() {
      this.isShowAllFormItems = false
      this.dialogVisible = false;
      this.currentItem = this.items[this.activeIndex].link;
      this.formData["tbl"] = this.items[this.activeIndex].tbl;
      const ele = document.querySelector("._tabs");
      ele.style.display = "block";

      if (this.formData["tbl"] === "portal_target_download") {
        // this.formData.flex=1;
      } else {
        delete this.formData.flex;
      }
    },
    reFlex: function () {
      this.filters.currentPage = 1;
      this.total = 0;
      // this.tableData = [];
      // this.getList();
    },
    reGetList: function () {
      this.filters.currentPage = 1;
      this.getList();
    },
    remoteMethod(e, item) {
      debounce(() => {
        // console.log(e, item);
        // console.log("remoteMethod remoteMethod");
        item.currentPage = 1;
        this.getFormItemsOptionsList(item, e);
      });
    },
    showDialog() {
      this.dialogVisible = true;
    },
    toData2(val) {
      if (this.total === 0) {
        this.$confirm("先查询，再下载", "Tips", {
          type: "warning",
          customClass: 'customConfimClass'
        });
        return;
      }
      if (this.total > 1000000) {
        this.$confirm(
            this.total+"条记录，"+"为确保系统运行可支持下载条目数上限为一百万行，建议筛选“省份”信息后再进行下载",
          "Tips",
          {
            type: "warning",
						customClass: 'customConfimClass'
          }
        );
        return;
      }

      var table = this.formData["tbl"];
      if (this.formData["tbl"] === "portal_target_download") {
        table = "portal_target_cross_download";
        if (this.formData["flex"]) {
          if (this.formData.flex === 1) {
            table = "portal_target_cross_download";
          } else {
            table = "portal_target_vertical_download";
          }
        }
      }
      var arr = [];
      for (let formKey in this.form) {
        if (this.form[formKey] instanceof Array) {
          if (this.form[formKey].length > 0) {
            arr = arr.concat(
              formKey +
                "  in  (" +
                this.form[formKey].map((item) => "N'" + item + "'").join(",") +
                ")"
            );
          }
        } else {
          if (this.form[formKey] !== "") {
            arr = arr.concat(formKey + "  in  (N'" + this.form[formKey] + "')");
          }
        }
      }

      var param = Object.assign(
        {
          sSelectName: this.sSchemaName + "." + table,
          sSelectFieldName: this.formData['sSelectFieldName'],
          sSelectFilter: arr.join(" and "),
          sSchemaName: this.sSchemaName,
          reportName: this.items[this.activeIndex].link,
          sFileName: table + "_" + new Date().getTime() + ".csv",
          sFavorite: 0,
          extBody: 1,
          nType: 1,
        },
        this.form
      );
      addDownloadExport(param).then((res) => {
        this.$message("download success！");
      });
    },
  },
};
</script>

<style scoped>
.el-form-item {
  margin-bottom: 0px;
  .el-input {
    width: 160px;
  }
  .el-select {
    width: 160px;
  }

  .el-form-item__label {
    line-height: unset;
    min-height: 32px;
    display: inline-flex;
    align-items: center;
    word-break: break-word;
  }

  .el-select {
   .el-select__tags {
     overflow: hidden;
     display: -webkit-box;
     -webkit-line-clamp: 2;
     -webkit-box-orient: vertical;
     .el-tag {
       display: inline-block;
       
       .el-select__tags-text {
         display: inline-block;
         max-width: 90px;
         overflow: hidden;
         text-overflow: ellipsis;
         white-space: nowrap;
       }
       .el-icon-close {
         top: -6px;
         right: -4px;
       }
     }
   }
 }

}
/* 针对el-select内部显示选中值的元素 */
.el-select.el-input__inner {
  text-align: left;
  padding-left: 30px; /* 设置居左像素为10px，可按需调整 */
}

/* 针对el-select下拉菜单中的选项元素 */
.el-select-dropdown__item {
  text-align: left;
  padding-left: 30px;
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-checkbox {
  text-align: left;
  padding-left: 6px;
}
.dialog-content {
  .item {
    font-size: 16px;
    padding: 2px;
    padding-left: 8px;
    margin: 15px 0;
    border-left: 4px solid #edf0f3;
    cursor: pointer;
    &.active {
      color: #409eff;
    }
  }
}
.btn-select {
  background: #30ea03;
  margin-bottom: 10px;
  border: unset;
  font-size: 18px;
  color: #000000;
}
._tabs {
  display: none;
}
._tabs1 {
  display: none;
}

.open {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #000000;
  margin-top: 10px;
  cursor: pointer;

  img {
    width: 12px;
    height: 15px;
    margin-left: 12px;
  }
}

.line {
  width: 100%;
  height: 1px;
  /* background: #000000; */
  border-bottom: 1px solid #cccccc;
  margin: 10px 0;
}

.btn {
  width: 80px;
  height: 35px;
  border-radius: 10px;
  padding-top: 0;
  padding-bottom: 0;
}

.searchBox {
  /* width: 1866px; */
  /* min-height: 200px; */
  background: #ffffff;
  /* box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
  border-radius: 20px; */
}

.dialog-wrapper {
  :deep(.el-dialog) {
    .el-dialog__header {
      background: #000 !important;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
}

.select-report {
  .el-input {
    width: 400px;
  }
  .el-select {
    width: 400px;
  }
  .el-input__inner {
    background: #30ea03;
    color: #000;
    border: unset;
    text-align: center;
    font-weight: 500;
  }

  .el-input .el-select__caret {
    color: #000 !important;
  }
}


.report-popper {
 .popper__arrow::after {
    border-bottom-color:#30ea03 !important;
  }
}
</style>



// WEBPACK FOOTER //
// select.vue?4a6fdd58